import { Routes, UrlSegment } from '@angular/router';
import { AdminLayout } from './layout/layout';
import { CompaniesListComponent } from './companies/companies-list.component';
import { CompanySingleComponent } from './companies/company-single/company-single.component';
import { JobSingleComponent } from './jobs/job-single/job-single.component';
import { JobsSearchComponent } from './jobs/jobs-search/jobs-search.component';
import { BrowseJobsIndexComponent } from './jobs/browse-jobs/index/browse-jobs-index.component';
import { BrowseJobsTaxonomyComponent } from './jobs/browse-jobs/taxonomy/browse-jobs-taxonomy.component';
import { RootComponent } from './root/root.component';

const routes: Routes = [
  {
    path: '',
    component: AdminLayout,
    children: [

      // -----------------------------------------------------------------------
      // Root
      // -----------------------------------------------------------------------
      {
        path: '',
        component: RootComponent,
      },

      //companies
      {
        path: 'companies',
        pathMatch: 'full',
        component: CompaniesListComponent,
      },

      {
        path: 'companies/:slug',
        component: CompanySingleComponent,
      },
      
      {
        path: 'companies/:slug/jobs/:jobPositionId',
        component: JobSingleComponent,
      },

      //jobs
      {
        path: 'jobs',
        component: JobsSearchComponent,
      },
      
      // {
      //   path: 'browse-jobs',
      //   component: BrowseJobsIndexComponent,
      // },
      // {
      //   path: 'browse-jobs/:browsePath',
      //   component: BrowseJobsTaxonomyComponent,
      // },

      {
        path: 'browse-jobs',
        children: [
          {
            path: '',
            component: BrowseJobsIndexComponent,
          },
          {
            matcher: (segments) => {
              if (segments.length === 0) return null;
              return {
                consumed: segments,
                posParams: {
                  browsePath: new UrlSegment(
                    segments.map(s => s.path).join('/'),
                    {}
                  ),
                },
              };
            },
            component: BrowseJobsTaxonomyComponent,
          },
        ],
      },
      
      

      // 404
      {
        path: '404',
        pathMatch: 'full',
        loadComponent: () =>
          import('./modules/extras/error/features/error-404'),
      },

      // Catch all
      { path: '**', redirectTo: '404' },
    ],
  },
];

export default routes;
